import wixData from 'wix-data';
// Filename: public/configuration/mainPageConfiguration.js 
//
// Code written in public files is shared by your site's
// Backend, page code, and site code environments.
//
// Use public files to hold utility functions that can 
// be called from multiple locations in your site's code.

export function getItemsForGallery() {
    let itemsArray = [];
    let imageForGallery;

    wixData.query("sliderData")
        .find()
        .then((results) => {
            results.items.forEach((item) => {
                imageForGallery = {
                    "type": "image",
                    "alt": item.title,
                    "title": item.title,
                    "src": item.url
                }
                itemsArray.push(imageForGallery)
            })

        })
    console.log(itemsArray);
    console.log("end")
    return itemsArray;
}
/* 
import {getItemsForGallery} from 'public/configuration/mainPageConfiguration.js'

$w.onReady(function () {	
    let sum = add(6,7);
    console.log(sum);
});
*/
export function getItemsConfiguration() {
    const itemsConfiguration = {
        dostoewski: {
            "de": [{
                sqimageDe: "https://static.wixstatic.com/media/98a66b_ef670e5b70af411797e729bcce6e1099~mv2.jpg",
				sqimage: "https://static.wixstatic.com/media/98a66b_ef670e5b70af411797e729bcce6e1099~mv2.jpg",
                link: "https://www.russisches-haus.de/dostojewski-jahr",
                text:"vv"
            }]
			,
            "ru": [{
                sqimage: "https://static.wixstatic.com/media/98a66b_ef670e5b70af411797e729bcce6e1099~mv2.jpg",
                link: "https://www.russisches-haus.de/dostojewski-jahr?lang=de",
                text:"vv"

            }]
        },
        "label": {
            "de": "Mehr erfahren",
            "ru": "Подробнее"
        },
        "postfix": {
            "de": "?lang=de",
            "ru": ""
        },
        "kategorie": {
            "News": {
                src: {
                    de: "imageDe",
                    ru: "imageRu"
                },
                text: {
                    de: "textDe",
                    ru: "textRu"
                },
                link: {
                    true: 'link-news-title',
                    undefined: 'link-news-1-title'
                },
                sectionLink: "link-news-all"

            },
            "Curs": {
                 src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: 'link-events-2-title',
                sectionLink: "link-events-2-title"

            },
			"Dostojewski": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-events-1-ausId-7",
                sectionLink: "link-events-1-ausId-7"

            },
            "WissenschaftJahr": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-events-1-ausId-9",
                sectionLink: "link-events-1-ausId-9"

            },
            "Wissenschaft": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                //link:'link-events-1-ausId-8',
                link: "link-events-wissenschaft-wisId",
                sectionLink: "link-events-wisID-all"

            },
            "Bildung": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-events-bildung-bildId",
                sectionLink: ""
            },
            "Projekte": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-events-1-title",
                sectionLink: "link-events-Projekte-all"

            },
            "LandsLeute": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "urlRu",
                sectionLink: "urlRu"

            },
            "Ausstellung": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-ausstellungen-ausId",
                sectionLink: "link-events-Ausstellungen-all"

            },
            "university": {
                src: {
                    de: "sQimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-university-title",
                sectionLink: "link-university-1-title"

            },
            "Kino": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-events-idView",
                sectionLink: "link-events-Kinos-all"
            },
            "Vorstellung": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-events-idView",
                sectionLink: "link-events-Vorstellungen-all"
            },
            "DEFAULT": {
                src: {
                    de: "sqimageDe",
                    ru: "sqimage"
                },
                text: {
                    de: "grundBeschreibungDe",
                    ru: "grundBeschreibungRu"
                },
                link: "link-events-idView",
                sectionLink: ""
            }
        },
        "slider": {
            ru: {
                src: 'image',
                name: 'nameRu'

            },
            de: {
                src: 'imageDe',
                name: 'nameDe'
            }

        }
    };
    return itemsConfiguration;
}

function compare(a, b) {

    const eventA = a._createdDate;
    const eventB = b._createdDate;

    let comparison = 0;
    if (eventA < eventB) {
        comparison = 1;
    } else if (eventA > eventB) {
        comparison = -1;
    }
    return comparison;
}

// The following code demonstrates how to call the add
// function from your site's page code or site code.

/* 
import {add} from 'public/configuration/mainPageConfiguration.js'

$w.onReady(function () {	
    let sum = add(6,7);
    console.log(sum);
});
*/

//The following code demonstrates how to call the add 
//function in one of your site's backend files.

/* 
import {add} from 'public/configuration/mainPageConfiguration.js'

export function usingFunctionFromPublic(a, b) {
	return add(a,b);
}
*/